export default {"src":"/_next/static/media/video-during.24aa7292.gif","height":199,"width":192,"blurWidth":0,"blurHeight":0};